var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"themeToggle"},[_c('input',{attrs:{"type":"checkbox"},on:{"click":_vm.theme}}),_c('div')])}
var staticRenderFns = []

export { render, staticRenderFns }